import { Component, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoService } from "@ngneat/transloco";
import { debounceTime, Subject, Subscription } from 'rxjs';
import { LOGIN_ROUTE } from 'src/app/app-routing.module';
import { environment } from "@environment";
import { ActionResult, Country, EventItem, EventItemType, FetchEventByIdRequest, Lookups } from "@model";
import { ActionService, AuthenticationService, EventRaceService, EventService, TOAST_STATE, ToastService } from "@services";
import { AbstractComponent } from "../abstract.component";
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-event-grid-item-with-image-small',
  templateUrl: './event-grid-item-with-image-small.component.html',
  styleUrls: ['./event-grid-item-with-image-small.component.scss'],
  providers: [DatePipe]
})
export class EventGridItemWithImageSmall extends AbstractComponent {
  @Input() eventItem: EventItem | undefined;
  @Input() eventItemType: EventItemType | undefined;
  @Input() additionalClass: string | undefined;
  @Input() isLanding: boolean = false;
  @Input() isFinishedEvent: boolean = false;
  @Input() countries: Lookups[] = [];
  @Input() isOnWishList: boolean = false;
  @Input({ required: true }) languages: Lookups[] = [];
  @Output() favoriteItems: EventItem[] = [];

  country: string | undefined;
  eventCountry: Country | undefined;
  listSizeBreakpoint: number = environment.eventItemLengthsSizeUiBreakpoint;

  private addToFavoritesButtonSubject = new Subject<EventItem | undefined>();

  constructor(public translocoService: TranslocoService, private router: Router, private authenticationService: AuthenticationService,
    private offcanvasService: NgbOffcanvas, private eventRaceService: EventRaceService, private actionService: ActionService,
    private datePipe: DatePipe, private eventService: EventService, private toastService: ToastService) {
    super();
  }

  ngOnInit(): void {
    this.getCountryName(this.eventItem?.country);
    this.setEventCountry();
  }

  setEventCountry() {
    if (this.countries !== null && this.countries.length > 0 && this.eventItem && this.eventItem.country) {
      let country: Lookups | undefined = this.countries.find((item: Lookups) => item.id === this.eventItem!.country);
      if (country) {
        this.eventCountry = country;
      }
    }
  }

  getCountryName(countryCode: number | undefined) {
    this.countries?.find((country: Country) => {
      if (countryCode === country.id) {
        this.country = country?.shortCode;
      }
    });
  }

  validCityAndCountry(country: string | undefined, city: string | undefined): string {
    if (country && city) {
      return city + ", " + country;
    } else if (country) {
      return country;
    } else if (city) {
      return city;
    }
    return '';
  }

  subscribeToAddToFavoritesButton(): Subscription {
    return this.addToFavoritesButtonSubject.pipe(debounceTime(environment.debounceActionInterval)).subscribe((eventItem: EventItem | undefined) => {
      if (this.authenticationService.isAuthenticated()) {
        this.addToFavoritesAction(eventItem);
      } else {
        this.toastService.showToast(TOAST_STATE.warning,this.translocoService.translate("event.favorite.save.warning"));
      }
    }
    );
  }

  addToFavoritesButtonClicked(event: MouseEvent, eventItem?: EventItem): void {
    event.preventDefault()
    event.stopPropagation()
    if (this.authenticationService.isAuthenticated()) {
      this.addToFavoritesAction(eventItem);
    } else {
      this.toastService.showToast(TOAST_STATE.warning,this.translocoService.translate("event.favorite.save.warning"));
    }
  }


  addToFavoritesAction(eventItem?: EventItem): void {
    if (eventItem?.id) {
      this.eventService.findEventById(new FetchEventByIdRequest(eventItem.id)).subscribe((value: EventItem | null) => {
        if (value) {
          if (value.id && value.favorite) {
            this.eventService.removeEventFromFavorites(value.id).subscribe((actionResult: ActionResult<boolean>) => {
              if (actionResult.result) {
                eventItem.favorite = false;
                this.eventService.fetchUserFavoritesEvent().subscribe((actionResult: EventItem[])=>{
                  this.favoriteItems=actionResult;
                })
              }
            });
            this.toastService.showToast(TOAST_STATE.success,this.translocoService.translate("event.favorite.delete.success"));
          } else if (value.id && !value.favorite) {
            this.eventService.addEventToFavorites(value.id).subscribe((actionResult: ActionResult<boolean>) => {
              if (actionResult.result) {
                eventItem.favorite = true;
              }
            });
            this.toastService.showToast(TOAST_STATE.success,this.translocoService.translate("event.favorite.save.success"));
          }
        }
      });
    }
  }

  goToLogin(): void {
    this.offcanvasService.dismiss();
    this.router.navigate([LOGIN_ROUTE]);
  }

  formatDate(date: Date | string): string {
    const month = this.datePipe.transform(date, 'MMM');
    return month ? month.slice(0, 3) : '';
  }

  protected readonly environment = environment;
}
